import { LayoutDashboard, Heart, Sparkles, ShoppingCart } from "lucide-react";
import PortalLayout from "@/components/portal/PortalLayout";

const LINKS = [
  { to: "/advertiser", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/advertiser/shortlist", label: "Shortlist", icon: Heart },
  { to: "/advertiser/plans", label: "AI Plans", icon: Sparkles },
  { to: "/advertiser/orders", label: "Orders", icon: ShoppingCart },
];

export default function AdvertiserLayout() {
  return <PortalLayout title="Advertiser" links={LINKS} allowedRoles={["advertiser", "super_admin"]} testId="advertiser-portal" />;
}
